export const PXCopyForm = (function () {
	'use strict';

	function init() {
		const tabButtons = document.querySelectorAll('.form-main__tab-buttons > button');
		const formTabs = document.querySelectorAll('.form-main__tab');

		if (tabButtons.length === 0) return;

		tabButtons.forEach((tabButton) => {
			tabButton.addEventListener('click', (ev) => {
				if (tabButton.classList.contains('active')) return;

				const $targetFormEl = $('div[id="'+tabButton.dataset.targetForm+'"]');

				tabButtons.forEach((tb) => tb.classList.remove('active'));
				formTabs.forEach((ft) => ft.classList.remove('active'));

				tabButton.classList.add('active');
				$targetFormEl.addClass('active');
			});
		});
	}

	return {
		init: init,
	};
})();
